<template>
  <div  v-if="item && userType == 'B2B' && label_stock_availability !== false" class="stock-av">
    <small>
      <b>
        {{ label_stock_availability }}
      </b>
    </small>
    <span :class="stockStatusIcon" class="status"></span>
    <small>{{ stockStatusText }}</small>
  </div>
</template> 

<script>
import availabilityMixin from '../../mixins/availabilityMixin';
import { getRegionConfig } from '../../utils/regionConfig';
import { buildNetSuiteStockUrl } from '../../utils/netsuiteUrlBuilder';

export default {
  name: "product-stock-availability-child",
  mixins: [availabilityMixin],
  props: {
    data: {
      type: Object,
    },
   
  },
  data() {
    return {
      availabilityAU: null,
      userType: 'B2C',
      itemStockCode: this.data.stockCode,
    };
  },
  computed: {
    locId() {
      return getRegionConfig(window.culture).locId;
    },
    regionId() {
      return getRegionConfig(window.culture).regionId;
    },
  },
  mounted() {
    this.isB2bUser();
  },
  methods: {
    isB2bUser() {
      this.userType = this.$store.getters["auth/userType"]; 
    },
  },
};
</script>

<style lang="scss" scoped>
.stock-av {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .availability {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 5px;
  }
  .status {
    margin: 0.6rem;
    &.in_store {
      background-color: green;
    }
    &.available_for_backorder {
      background-color: darkorange;
    }
    &.out_of_stock {
      background-color: darkred;
    }
  }
  @media screen and (max-width: 768px) {
    justify-content: center;
  }
}
</style>

